let state = {
    tags: [], //面包屑导航
    userInfo: {}, //用户信息
    menuState: false, //菜单收起状态
    menu: [], //菜单
    axiosMsg: true, //接口是否弹出提示信息(暂时没用)
}
let mutations = {
        // 改变是否弹出提示信息
        CHANGE_AXIOSMSG: (state, blur) => {
            state.axiosMsg = blur;
        },
        // 改变面包屑导航
        // @nowRouter 当前路由
        CHANGE_TAGS: (state, nowRouter) => {
            let localTags = localStorage.getItem('tags');
            let now = {
                path: nowRouter.path,
                title: nowRouter.meta.title,
                query: nowRouter.query
            }
            let tags = [];
            if (localTags && localTags.length) {
                tags = JSON.parse(localTags);
                let flagIndex = tags.findIndex(item => {
                    return item.path == nowRouter.path;
                });
                if (flagIndex == -1) {
                    tags.push(now);
                } else {
                    tags[flagIndex] = now;
                }
            } else {
                tags.push(now);
            }
            state.tags = tags;
            localStorage.setItem('tags', JSON.stringify(tags));
        },
        // 删除面包屑导航
        DEl_TAGS: (state, nowPath) => {
            state.tags.forEach((item, index) => {
                if (item.path == nowPath) {
                    state.tags.splice(index, 1);
                }
            });
            localStorage.setItem('tags', JSON.stringify(state.tags));
        },
        // 改变用户信息
        CHANGE_USERINFO: (state, userInfo) => {
            state.userInfo = userInfo;
        },
        // 改变菜单收起状态
        CHANGE_MENUSTATES: (state, flag) => {
            state.menuState = !state.menuState;
        },
        // 页面左侧菜单 
        CHANGE_MENU: (state, arr) => {
            let menu = arr[0].children;
            menu.forEach((item) => {
                item.level = 1; //菜单icon颜色显示使用
            })
            state.menu = menuFilter(menu);
        }
    }
    // 0左侧菜单 1 按钮 2顶部菜单（只有0会显示）
function menuFilter(menu) {
    let tree = menu;
    for (let i = 0; i < tree.length; i++) {
        let itemI = tree[i];
        if (itemI.meta.type == "1" || itemI.meta.type == "2") {
            tree.splice(i, 1);
        }
        if (itemI.children && itemI.children.length) {
            menuFilter(itemI.children);
        }
    }
    return tree
}

let actions = {}

let getters = {
    getTags(state) {
        return state.tags;
    },
    getUserInfo(state) {
        return state.userInfo;
    },
    getMenuState(state) {
        return state.menuState;
    },
    getMenu(state) {
        return state.menu;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/vuex/modules/user.js